/**
 * 教研中心api
 */
import { getFetch } from '@/plugins/http'
import { postFetch } from '@/plugins/http'

const baseHost = `${process.env.VUE_APP_HOST}/hike-boot`

export default {
  /**
   * 教研中心-会议类型列表
   * @param {*} params
   * @param {*} config
   * @returns
   */
  getMeetingTypeList(params = {}, config) {
    return getFetch(`${baseHost}/common/api/33-get_activity_type_list/teachingCentret`, params, config)
  },
  /**
   * 教研中心-获取表单信息
   * @param {*} params
   * @param {*} config
   * @returns
   */
  getMeetingForm(params = {}, config) {
    return getFetch(`${baseHost}/common/api/33-getFormField/teachingCentret`, params, config)
  },
  /**
   * 教研中心-我参与的会议列表
   * @param {*} params
   * @param {*} config
   * @returns
   */
  getMyMeetinglist(params = {}, config) {
    return getFetch(`${baseHost}/common/api/34-getActivityListByUser/teachingCentret`, params, config)
  },
  /**
   * 教研中心-备课课程列表
   * @param {*} params
   * @param {*} config
   * @returns
   */
  getBkCourseList(params = {}, config) {
    return getFetch(`${baseHost}/common/api/33-al_course_list/teachingCentret`, params, config)
  },
  /**
   * 教研中心-授课学生专业列表
   * @param {*} params
   * @param {*} config
   * @returns
   */
  getStudentMajorList(params = {}, config) {
    return getFetch(`${baseHost}/common/api/33-get_major_list/teachingCentret`, params, config)
  },
  /**
   * 教研中心-课程类别列表
   * @param {*} params
   * @param {*} config
   * @returns
   */
  getCourseClassifyList(params = {}, config) {
    return getFetch(`${baseHost}/common/api/33-bk_course_classify_list/teachingCentret`, params, config)
  },
  /**
   * 教研中心-备课形式列表
   * @param {*} params
   * @param {*} config
   * @returns
   */
  getCourseFormList(params = {}, config) {
    return getFetch(`${baseHost}/common/api/33-live_classify_list/teachingCentret`, params, config)
  },
  /**
   * 教研中心-选择人员列表
   * @param {*} params
   * @param {*} config
   * @returns
   */
  getSelectUserList(params = {}, config) {
    return getFetch(`${baseHost}/common/api/34-select_user_list/teachingCentret`, params, config)
  },
  /**
   * 教研中心-新增表单
   * @param {*} params
   * @param {*} config
   * @returns
   */
  saveMeeting(params = {}) {
    return postFetch(`${baseHost}/common/api/10-saveForm/teachingCentret`, params, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
  },
  getActivityInfo(params = {}, config) {
    return getFetch(`${baseHost}/common/api/32-getActivityInfo/teachingCentret`, params, config)
  },
  /**
   * 教研中心-弹幕列表
   * @param {*} params
   * @param {*} config
   * @returns
   */
  getCommentList(params = {}, config) {
    return getFetch(`${baseHost}/common/api/33-get_comment_list/teachingCentret`, params, config)
  },
  /**
   * 教研中心-提交弹幕
   * @param {*} params
   * @param {*} config
   * @returns
   */
  addCommentList(params = {}, config) {
    return postFetch(`${baseHost}/common/api/10-save_comment/teachingCentret`, params, config)
  },
  /**
   * 教研中心-获取当前活动类型登录人权限
   * @param {*} params
   * @param {*} config
   * @returns
   */
  getActivityUserRole(params = {}, config) {
    return getFetch(`${baseHost}/common/api/33-getActivityUserRole/teachingCentret`, params, config)
  },
  // 教研中心-会议详情-附件列表
  getActivityFileList(params = {}, config) {
    return getFetch(`${baseHost}/common/api/30-getActivityFileList/teachingCentret`, params, config)
  },
  // 教研中心-会议详情-删除附件
  delActivityFile(params = {}, config) {
    return postFetch(`${baseHost}/common/api/90-del_field_file/teachingCentret`, params, config)
  },
  // 教研中心-会议详情-新增附件
  addActivityFile(params = {}, config) {
    return postFetch(`${baseHost}/common/api/10-save_field_file/teachingCentret`, params, config)
  },
  /**
   * 教研中心-教研室身份列表
   * @param {*} params
   * @param {*} config
   * @returns
   */
  getTeachingRoomRole(params = {}, config) {
    return getFetch(`${baseHost}/common/api/33-bk_course_role_list/teachingCentret`, params, config)
  },
  // 教研中心-工作记录-教研表单信息
  getActivityFormInfo(params = {}, config) {
    return getFetch(`${baseHost}/common/api/32-getActivityFormInfo/teachingCentret`, params, config)
  },
  /**
   * 教研中心-工作记录-删除会议
   * @param {*} params
   * @param {*} config
   * @returns
   */
  deleteTeachingMeeting(params = {}, config) {
    return postFetch(`${baseHost}/common/api/90-del_teaching_activity/teachingCentret`, params, config)
  },
  /**
   * 教研中心-我的教研室列表
   * @param {*} params
   * @param {*} config
   * @returns
   */
  getMyCourseGroup(params = {}, config) {
    return getFetch(`${baseHost}/common/api/33-my_jiaoyanshi_list/teachingCentret`, params, config)
  },
  // 教研中心-会议详情-工作记录列表
  getActivityWorkRecorList(params = {}, config) {
    return getFetch(`${baseHost}/common/api/32-getActivityWorkRecorList/teachingCentret`, params, config)
  },
  // 教研中心-会议详情-工作记录修改
  updateActivityWorkRecord(params = {}, config) {
    return postFetch(`${baseHost}/common/api/20-update_work_record/teachingCentret`, params, config)
  },
  // 教研中心-会议详情-工作记录添加
  addActivityWorkRecord(params = {}, config) {
    return postFetch(`${baseHost}/common/api/10-saveWorkRecord/teachingCentret`, params, config)
  },
  // 教研中心-会议详情-工作记录删除
  delActivityWorkRecord(params = {}, config) {
    return postFetch(`${baseHost}/common/api/90-del_work_record/teachingCentret`, params, config)
  },
  /**
   * 教研中心-工作记录-会议列表
   * @param {*} params
   * @param {*} config
   * @returns
   */
  getRecordMeetingList(params = {}, config) {
    return getFetch(`${baseHost}/common/api/34-getActivityList/teachingCentret`, params, config)
  },
  // 教研中心-教研室介绍
  getJiaoyanshiIntroduction(params = {}, config) {
    return getFetch(`${baseHost}/common/api/32-jiaoyanshi_introduction/teachingCentret`, params, config)
  },
  // 教研中心-教研室介绍-团队成员
  getJiaoyanshiMemberApi(params = {}, config) {
    return getFetch(`${baseHost}/common/api/32-team_member/teachingCentret`, params, config)
  },
  // 教研中心-保存基本信息
  saveJiaoyanshiBaseInfo(params = {}, config) {
    return postFetch(`${baseHost}/common/api/20-upd/bk_course_group`, params, config)
  },
  // 教研中心-保存标题
  saveJiaoyanshiModuleTitle(params = {}, config) {
    return postFetch(`${baseHost}/common/api/20-column_upd/general_website`, params, config)
  },
  // 教研中心-批量修改
  saveJiaoyanshiInfo(params = {}, config) {
    return postFetch(`${baseHost}/common/api/20-column_content_upds/general_website`, params, config)
  },
  // 教研中心-结束会议
  endTeachingActivity(params = {}, config) {
    return postFetch(`${baseHost}/common/api/20-endTeachingActivity/teachingCentret`, params, config)
  },
  // 教研中心-我参与的(最新的会议室)
  getMyJoinMeeting(params = {}, config) {
    return getFetch(`${baseHost}/common/api/32-getActivityByUser/teachingCentret`, params, config)
  },
  // 教研中心-获取服务器时间
  getServiceTime(params = {}, config) {
    return getFetch(`${baseHost}/common/api/30-get_service_time/teachingCentret`, params, config)
  },
  /**
   * 教研室全部
   */
  getTeachingGroupList(params, config) {
    return getFetch(`${baseHost}/common/api/33-bk_course_group_list2/teachingCentret`, params, config)
  },
  // 查询实时会中成员列表
  getTecentMeetingMemberList(params, config) {
    return getFetch(`${baseHost}/txhy/getRealTimeParticipants`, params, config)
  },
  // 设置联席主持人
  setMeetingPresenter(params, config) {
    return postFetch(`${baseHost}/txhy/setCohosts`, params, config)
  },
  // 是否绑定腾讯会议
  isBindMeeting(params, config) {
    return getFetch(`${baseHost}/txhy/whetherBind`, params, config)
  },
  /******************************* 数据中心 ****************************************************/
  // 教研中心-数据中心-数据总览
  getDataCenter(params = {}, config) {
    return getFetch(`${baseHost}/common/api/32-data_screening/jyzx_data_center`, params, config)
  },
  // 教研中心-数据中心-教师统计
  getTeacherStatistics(params = {}, config) {
    return getFetch(`${baseHost}/common/api/32-teacher_statistics/jyzx_data_center`, params, config)
  },
  // 教研中心-数据中心-教研活动类别占比
  getTeachingActivityType(params = {}, config) {
    return getFetch(`${baseHost}/common/api/33-teaching_activity_type_ratio/jyzx_data_center`, params, config)
  },
  // 教研中心-数据中心-教研活动开展趋势
  getTeachingActivityTrend(params = {}, config) {
    return getFetch(`${baseHost}/common/api/33-teaching_activity_develop_trend/jyzx_data_center`, params, config)
  },
  // 教研中心-数据中心-各教研室活动开展量
  getTeachingActivityCount(params = {}, config) {
    return getFetch(`${baseHost}/common/api/33-teaching_activity_develop_num/jyzx_data_center`, params, config)
  },
  // 教研中心-数据中心-教研资源类别占比
  getTeachingResource(params = {}, config) {
    return getFetch(`${baseHost}/common/api/33-teaching_case_type_ratio/jyzx_data_center`, params, config)
  },
  // 教研中心-数据中心-教研资源上传趋势
  getTeachingResourceTrend(params = {}, config) {
    return getFetch(`${baseHost}/common/api/33-teaching_case_upload_trend/jyzx_data_center`, params, config)
  },
  // 教研中心-数据中心-各教研室教研资源量
  getTeachingResourceCount(params = {}, config) {
    return getFetch(`${baseHost}/common/api/33-teaching_case_upload_num/jyzx_data_center`, params, config)
  },
  // 教研中心-数据中心-教研室分析
  getTeachingAnalysis(params = {}, config) {
    return getFetch(`${baseHost}/common/api/33-course_group_analysis/jyzx_data_center`, params, config)
  },
  // 教研中心-数据中心-教师分析
  getTeacherAnalysis(params = {}, config) {
    return getFetch(`${baseHost}/common/api/34-course_group_teacher_analysis/jyzx_data_center`, params, config)
  },
  // 教研中心-数据中心-权限
  getTeachingCenterPermission(params = {}, config) {
    return getFetch(`${baseHost}/common/api/32-auth/jyzx_data_center`, params, config)
  },
  // 教研中心-数据中心-管理的教研室列表
  getMyManageTeachingRoomList(params = {}, config) {
    return getFetch(`${baseHost}/common/api/33-manage_group_list/jyzx_data_center`, params, config)
  },
  // 数据中心-计划完成情况
  getTeachingPlanComplete(params = {}, config) {
    return getFetch(`${baseHost}/common/api/32-getPlannedCompletion/teaching_plan`, params, config)
  },

  /******************************* 教研协作 ****************************************************/
  // 教研中心-教研课程-选择列表
  getTeachingCourseList(params = {}, config) {
    return getFetch(`${baseHost}/common/api/33-select_list/jyzx_teaching_course`, params, config)
  },
  // 教研中心-教研课程-章节树
  getTeachingCourseChapterTree(params = {}, config) {
    return getFetch(`${baseHost}/common/api/33-tree_outline/jyzx_teaching_course`, params, config)
  },
  // 教研中心-教研课程-章节新增
  addTeachingCourseChapter(params = {}, config) {
    return postFetch(`${baseHost}/common/api/10-add_outline/jyzx_teaching_course`, params, config)
  },
  // 教研中心-教研课程-章节修改
  updateTeachingCourseChapter(params = {}, config) {
    return postFetch(`${baseHost}/common/api/20-upd_outline/jyzx_teaching_course`, params, config)
  },
  // 教研中心-教研课程-章节排序
  sortTeachingCourseChapter(params = {}, config) {
    return postFetch(`${baseHost}/common/api/20-sort_outline/jyzx_teaching_course`, params, config)
  },
  // 教研中心-教研课程-章节删除
  deleteTeachingCourseChapter(params = {}, config) {
    return postFetch(`${baseHost}/common/api/91-del_outline/jyzx_teaching_course`, params, config)
  },
  // 教研中心-教研协作-列表
  getTeachingCollaborationList(params = {}, config) {
    return getFetch(`${baseHost}/common/api/34-my_list/jyzx_all_resource`, params, config)
  },
  // 教研中心-共享资源-列表
  getShareResourceList(params = {}, config) {
    return getFetch(`${baseHost}/common/api/34-share_list/jyzx_all_resource`, params, config)
  },

  /*************************************** 工作计划 **********************************************/
  // 门户_教研计划_填报列表
  getWorkPlanList(params = {}, config) {
    return getFetch(`${baseHost}/common/api/33-out_plan_page_list_batch/teaching_plan`, params, config)
  },
  // 任务填报_新增
  addWorkPlan(params = {}, config) {
    return postFetch(`${baseHost}/common/api/10-plan_fill_out_save/teaching_plan`, params, config)
  },
  // 任务填报_更新
  updateWorkPlan(params = {}, config) {
    return postFetch(`${baseHost}/common/api/20-plan_fill_out_update/teaching_plan`, params, config)
  },
  // 任务填报_根据id查询
  getWorkPlanById(params = {}, config) {
    return getFetch(`${baseHost}/common/api/30-plan_fill_out_info/teaching_plan`, params, config)
  },
  // 当前项目是否有计划菜单权限
  isHasPlanMenu(params = {}, config) {
    return getFetch(`${baseHost}/common/api/32-has_function/menu_function`, params, config)
  },
  // 门户_教研计划_计划选择列表
  getSelectPlanList(params = {}, config) {
    return getFetch(`${baseHost}/common/api/34-select_out_plan_page_list/teaching_plan`, params, config)
  },
  //  门户_教研计划_填报列表_审核通过的
  getPassWorkPlanList(params = {}, config) {
    return getFetch(`${baseHost}/common/api/34-out_plan_page_list_reviewPass/teaching_plan`, params, config)
  },
  // 获取导出计划key
  getExportPlanId(params = {}, config) {
    return getFetch(`${baseHost}/common/api/30-getExportPlanKey/teaching_plan`, params, config)
  },
  // 获取导出计划数据
  getExportPlanInfo(params = {}, config) {
    return getFetch(`${baseHost}/common/api/30-getExportPlanData/teaching_plan`, params, config)
  },
  // 获取用户在教研室身份
  getUserGroupRole(params = {}, config) {
    return getFetch(`${baseHost}/common/api/30-getGroupUserRole/teaching_plan`, params, config)
  },
  // 任务填报_删除
  deleteWorkPlan(params = {}, config) {
    return postFetch(`${baseHost}/common/api/91-plan_out_del/teaching_plan`, params, config)
  },
  // 获取腾讯会员授权域名
  getTencentDomain(params = {}, config) {
    return getFetch(`${baseHost}/common/api/32-txhy_domain/common_config`, params, config)
  },
}
